import CollapseManager from "../../js/components/collapseManager";
import ButtonGroupManager from "../../js/components/buttonGroupManager";

export default class CallRequestCustomer extends HTMLElement {
    constructor() {
        super();
        this.initialized = false;
    }

    static get observedAttributes() {
        return ['stylesheet', 'call-request-customer-data'];
    }

    connectedCallback() {
        this.data = JSON.parse(this.getAttribute('call-request-customer-data'));
        this.stylesheet = this.getAttribute('stylesheet');
        this.contactPhone = this.data.contactPhone;
        this.ticketCallRequestDays = this.data.ticketCallRequestDays;
        this.showCallMeNow = this.data.showCallMeNow;
        this.existentTicketCallRequest = (this.data.existentTicketCallRequest ? this.data.existentTicketCallRequest : {});
        this.showCallResponse = this.data.showCallResponse;
        this.ticketId = this.data.ticketId;
        this.summary = this.data.summary;
        this.phoneNumberText = this.data.phoneNumberText;
        this.incorrectPhone = this.data.incorrectPhone;
        this.phoneNotSelected = this.data.phoneNotSelected;
        this.phoneNumberButton = this.data.phoneNumberButton;
        this.wantUsToCallYou = this.data.wantUsToCallYou;
        this.callOtherMoment = this.data.callOtherMoment;
        this.callOtherMomentDays = this.data.callOtherMomentDays;
        this.saveCallRequestButton = this.data.saveCallRequestButton;
        this.internalErrorText = this.data.internalError;
        this.token = this.data.token;
        this.showWantUsToCallYou = this.data.showWantUsToCallYou;

        this._shadowRoot = this.attachShadow({mode: 'open'});
        const t = document.querySelector('#call-request-customer-template');
        this.instance = t.content.cloneNode(true);
        this.instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        //Phone Input
        this.incorrectPhoneLabel = this.instance.querySelector('[data-value="incorrect-phone"]');
        this.instance.querySelector('[name="incorrect-phone"]').innerHTML = this.incorrectPhone;
        this.inputTel = this.instance.querySelector('[name="phone-number"]');

        if (!this.showWantUsToCallYou) {
            this.instance.querySelector('.show-call-me-now-button-container').classList.add("hide");
        }

        this.instance.querySelector('[name="ticket-id"]').innerHTML = this.ticketId;
        this.instance.querySelector('[name="phone-number-text"]').innerHTML = this.phoneNumberText;
        this.instance.querySelector('[name="phone-not-selected"]').innerHTML = this.phoneNotSelected;
        this.instance.querySelector('[name="want-us-to-call-you"]').innerHTML = this.wantUsToCallYou;
        this.instance.querySelector('[name="internal-error-text"]').innerHTML = this.internalErrorText;

        this.callRequestCreatedNotification = document.querySelector('#request-call-created');
        this.callRequestDeletedNotification = document.querySelector('#request-call-deleted');
        this.invisibleLayerNotification = document.querySelector(`#invisible-layer-notification`);

        //Close notifications when click is made out of them in mobile
        if (this.invisibleLayerNotification) {
            this.invisibleLayerNotification.addEventListener('click', (e) => this.closeCallRequestNotification(e));
        }

        this.callRequestCustomerDiv = this.instance.querySelector('.call-request-customer');
        this.callRequestedCustomerDiv = this.instance.querySelector('.call-requested-customer');
        this.callRequestedCustomerDelete = this.callRequestedCustomerDiv.querySelector('[data-action="delete-call-requested"]');
        this.callRequestedCustomerDelete.addEventListener('click', () => this.deleteCallRequest());
        this.callRequestedCustomerModify = this.callRequestedCustomerDiv.querySelector('[data-action="modify-call-requested"]');
        this.callRequestedCustomerModify.addEventListener('click', () => {
            if (this.callRequestCreatedNotification.isOnScreen()) {
                this.callRequestCreatedNotification.closeCustomNotification()
            }
            this.openNewCallRequest();
        });

        this.callRequestedCustomerDiv.querySelector('.title').innerHTML = this.data.existentTicketCallRequestInfo.title;
        this.callRequestedCustomerDiv.querySelector('.text').innerHTML = this.data.existentTicketCallRequestInfo.infoCall;
        this.callRequestedCustomerDelete.innerText = this.data.existentTicketCallRequestInfo.cancelText;
        this.callRequestedCustomerModify.innerText = this.data.existentTicketCallRequestInfo.modifyText;

        if (this.existentTicketCallRequest && this.existentTicketCallRequest.id) {
            this.openCallRequested();
        } else {
            this.openNewCallRequest();
        }

        this._shadowRoot.appendChild(this.instance);

        this.showCallMeNowButtonTemplate = document.querySelector("#show-call-me-now-button-template");
        this.showCallMeNowButtonTemplateInstance = this.showCallMeNowButtonTemplate.content.cloneNode(true);
        this.createCallMeNowButton();

        this.hoursListTemplate = document.querySelector("#hours-list-template");

        this.hourButtonTemplate = document.querySelector("#hour-button-template");

        this.showCallMeOtherMomentTemplate = document.querySelector("#show-call-me-other-moment-template");
        this.showCallMeOtherMomentTemplateInstance = this.showCallMeOtherMomentTemplate.content.cloneNode(true);
        this.createCallMeOtherMoment();
        new CollapseManager(this._shadowRoot);
        new ButtonGroupManager(this._shadowRoot);

        this._shadowRoot.querySelectorAll('[data-action="save-call-request"][data-value="select-hour"]')
            .forEach(button => button.addEventListener('click', (event) => {
                if (this.isValidPhone()) {
                    const startHour = this._shadowRoot.querySelector('.active[data-action="confirm-hour"]').getAttribute('start-hour');
                    const endHour = this._shadowRoot.querySelector('.active[data-action="confirm-hour"]').getAttribute('end-hour');
                    const daySelected = this._shadowRoot.querySelector('.active[data-action="confirm-hour"]').getAttribute('data-day');
                    const dayTranslated = this._shadowRoot.querySelector('.active[data-action="confirm-hour"]').parentElement.parentElement.parentElement.parentElement.querySelector('[name="call-request-hours-list"]').textContent;
                    this.saveCallRequest(startHour, endHour, daySelected, dayTranslated)
                }
            }));
        this._shadowRoot.querySelector('[name="stylesheet"]').addEventListener('load', () => {
            this.style.display = '';
        });

        let event = new Event('call-request-customer-initialized');
        this._shadowRoot.dispatchEvent(event);
        this.initialized = true;
    }

    setPhone(value) {
        this.inputTel.setAttribute('value', '+' + value);
        this.contactPhone = value;
    }

    createCallMeNowButton() {
        let callMeNowContainer = this._shadowRoot.querySelector('.show-call-me-now-button-container');
        const callMeNowButton = this.showCallMeNowButtonTemplateInstance.querySelector('[data-action="instant-call-request"]')
        callMeNowButton.innerHTML = this.phoneNumberButton;
        callMeNowButton.addEventListener('click', () => this.instantCallRequest())
        callMeNowContainer.appendChild(this.showCallMeNowButtonTemplateInstance);
    }

    createCallMeOtherMoment() {
        let callMeOtherMomentContainer = this._shadowRoot.querySelector('[name="show-call-me-other-moment-container"]');

        if (this.showWantUsToCallYou) {
            this.showCallMeOtherMomentTemplateInstance.querySelector('[name="call-me-other-moment-title"]').innerHTML = this.callOtherMoment;
        }
        callMeOtherMomentContainer.appendChild(this.showCallMeOtherMomentTemplateInstance.cloneNode(true));

        this.callRequestHoursListContainer = this._shadowRoot.querySelector('[name="call-request-hours-list-container"]');

        for (let ticketCallRequestDay of this.ticketCallRequestDays) {
            this.createHoursList(ticketCallRequestDay);
        }

        this.showCallMeOtherMomentTemplateInstance.querySelector('[name="call-request-hours-list-container"]').appendChild(this.callRequestHoursListContainer.cloneNode(true));
    }

    createHoursList(ticketCallRequestDay) {
        this.hoursListTemplateInstance = this.hoursListTemplate.content.cloneNode(true);
        this.hoursListTemplateInstance.querySelector('[name="call-request-hours-list"]').innerHTML = this.callOtherMomentDays[ticketCallRequestDay.day];
        if (ticketCallRequestDay.dateFormatted) {
            this.hoursListTemplateInstance.querySelector('[name="call-request-hours-list-date"]').innerHTML = '(' + ticketCallRequestDay.dateFormatted + ')';
        }

        this.callRequestHourButtonContainer = this.hoursListTemplateInstance.querySelector('[name="call-request-hour-button-container"]');
        for (let ticketCallRequestDate of ticketCallRequestDay.ticketCallRequestDates) {
            this.createHourButton(ticketCallRequestDate, ticketCallRequestDay.day);
        }

        this.hoursListTemplateInstance.querySelector('[name="save-call-request-button"]').innerHTML = this.saveCallRequestButton;
        this.callRequestHoursListContainer.appendChild(this.hoursListTemplateInstance);
    }

    createHourButton(ticketCallRequestDate, day) {
        let startDate = new Date(ticketCallRequestDate.date.date);
        let endDate = new Date(ticketCallRequestDate.dateEnd.date);

        this.hourButtonTemplateInstance = this.hourButtonTemplate.content.cloneNode(true);
        const requestDate = this.hourButtonTemplateInstance.querySelector('[name="request-date"]');
        requestDate.querySelector('[name="select-hour-button"]').innerHTML = this.formatDate(startDate) + ' ' + this.data.existentTicketCallRequestInfo.hourToHour + ' ' + this.formatDate(endDate);
        requestDate.querySelector('[name="select-hour-button"]').setAttribute('start-hour', this.formatDate(startDate));
        requestDate.querySelector('[name="select-hour-button"]').setAttribute('end-hour', this.formatDate(endDate));
        requestDate.querySelector('[name="select-hour-button"]').setAttribute('data-day', day);

        if (ticketCallRequestDate.enabled) {
            this.callRequestHourButtonContainer.appendChild(this.hourButtonTemplateInstance.querySelector('[name="request-date"]').cloneNode(true));
        }
    }

    formatDate(date) {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;

        return hours + ':' + minutes;
    }

    isValidPhone() {
        return this.contactPhone != null;
    }

    validatePhone() {
        if (this.isValidPhone()) {
            this.incorrectPhoneLabel.classList.add('hide');
        } else {
            this.incorrectPhoneLabel.classList.remove('hide');
        }
    }

    displayInternalError() {
        this._shadowRoot.querySelector('[data-value="internal-error"]').hidden = false;
    }

    async instantCallRequest() {
        if (this.isValidPhone()) {
            const data = {
                bookingId: this.data.bookingId,
                ticketId: this.data.ticketId,
                phone: this.contactPhone,
                token: this.data.token,
                userLoggedId: this.data.userLoggedId,
            }

            const optionsRequest = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }

            const resInstantCallRequest = await fetch(this.data.urlInstantCall, optionsRequest);
            const dataInstantCallRequest = JSON.parse(await resInstantCallRequest.json());
            if (dataInstantCallRequest && dataInstantCallRequest.code == 200) {
                this.openCallRequestCreatedNotification();
            }
        }
    }

    async saveCallRequest(startDate, endDate, daySelected, dayTranslated) {
        if (this.isValidPhone()) {
            const data = {
                ticketId: this.data.ticketId,
                bookingId: this.data.bookingId,
                userLoggedId: this.data.userLoggedId,
                day: daySelected,
                hour: startDate,
                contactPhone: this.contactPhone,
                ticketCallRequestId: this.existentTicketCallRequest ? this.existentTicketCallRequest.id : null,
                token: this.data.token
            }

            const optionsRequest = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }

            const resSaveCallRequest = await fetch(this.data.urlSaveTicketCallRequest, optionsRequest);
            const dataSaveCallRequest = JSON.parse(await resSaveCallRequest.json());
            if (dataSaveCallRequest && dataSaveCallRequest.code == 200 && dataSaveCallRequest.ticketCallRequestId) {
                this.ticketId = dataSaveCallRequest.ticketId;
                this.existentTicketCallRequest.id = dataSaveCallRequest.ticketCallRequestId;
                let infoCall = this.data.existentTicketCallRequestInfo.infoCall;
                infoCall = infoCall.replace(/<span id="call-requested-day">.*?<\/span>/g, `<span id="call-requested-day">${dayTranslated}<\/span>`)
                infoCall = infoCall.replace(/<span id="call-requested-start-hour">.*?<\/span>/g, `<span id="call-requested-start-hour">${startDate}<\/span>`)
                infoCall = infoCall.replace(/<span id="call-requested-end-hour">.*?<\/span>/g, `<span id="call-requested-end-hour">${endDate}<\/span>`)
                this.callRequestedCustomerDiv.querySelector('.text').innerHTML = infoCall;
                this.openCallRequested()
                this.openCallRequestCreatedNotification();
            }
        }
    }

    async deleteCallRequest() {
        if (this.existentTicketCallRequest.id) {
            const data = {
                ticketCallRequestId: this.existentTicketCallRequest.id,
                ticketId: this.ticketId,
                token: this.token,
                userLoggedId: this.data.userLoggedId,
            }

            const optionsRequest = {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }
            const resDeleteCallRequest = await fetch(this.data.urlDeleteTicketCallRequest, optionsRequest);
            const dataDeleteCallRequest = JSON.parse(await resDeleteCallRequest.json());
            if (dataDeleteCallRequest && dataDeleteCallRequest.code == 200) {
                this.existentTicketCallRequest.id = null;
                this.openCallRequestDeletedNotification();
                this.openNewCallRequest();
            }
        }
    }

    openNewCallRequest() {
        this.callRequestCustomerDiv.classList.remove('hide')
        this.callRequestedCustomerDiv.classList.add('hide')
    }

    openCallRequested() {
        this.callRequestCustomerDiv.classList.add('hide')
        this.callRequestedCustomerDiv.classList.remove('hide')
    }

    openCallRequestCreatedNotification() {
        if (this.callRequestDeletedNotification.isOnScreen()) {
            this.callRequestDeletedNotification.closeCustomNotification();
        }
        this.callRequestCreatedNotification.openCustomNotification();
        this.showInvisibleLayer();
    }

    openCallRequestDeletedNotification() {
        if (this.callRequestCreatedNotification.isOnScreen()) {
            this.callRequestCreatedNotification.closeCustomNotification();
        }
        this.callRequestDeletedNotification.openCustomNotification();
        this.showInvisibleLayer();
    }

    showInvisibleLayer() {
        if (this.invisibleLayerNotification) {
            this.invisibleLayerNotification.classList.remove('hide');
        }
    }

    hideInvisibleLayer() {
        if (this.invisibleLayerNotification) {
            this.invisibleLayerNotification.classList.add('hide');
        }
    }

    closeCallRequestNotification(e) {
        e.stopPropagation();
        if (this.callRequestCreatedNotification.isOnScreen()) {
            this.callRequestCreatedNotification.closeCustomNotification();
            this.hideInvisibleLayer();
        }
        if (this.callRequestDeletedNotification.isOnScreen()) {
            this.callRequestDeletedNotification.closeCustomNotification();
            this.hideInvisibleLayer();
        }
    }
}
